<template>
  <div class="server-room">
    <Header/>
    <BackToTop bottom="50px" right="25px">
      <button type="button" class="btt-btn">UP</button>
    </BackToTop>
  
    <v-container grid-list-md text-xs-center class="server-room-btns">
      <div class="spacer" />

      <!-- server expiration -->
      <v-flex x12 v-if="serverExists">
        <span class="red--text">This Surv expires in ~{{expiration}} hour(s)</span>
      </v-flex>

      <v-layout row wrap>

        <!-- server url button -->
        <v-flex xs6 offset-xs1 sm3 offset-sm4>
          <v-text-field outline :value="serverUrl" label="URL" readonly class="url-cpy-btn" color="indigo" v-clipboard:copy="serverUrl" v-clipboard:success="onCopy"></v-text-field>
        </v-flex>
  
        <!-- question mark -->
        <v-flex xs1>
          <v-dialog width="500">
            <v-btn icon slot="activator" class="elevation-2">
              <img src="../assets/if_question-frame.png">
            </v-btn>
  
            <v-card>
              <v-card-title class="headline grey lighten-2" primary-title>
                Welcome
              </v-card-title>

              <v-card-text>
                This Surv will stay be available for the next 24 hours, it will no longer exist after that time is up
              </v-card-text>
              
              <v-divider></v-divider>
              
              <v-card-text>
                Anyone with this URL has access to any image that has been uploaded here. They can also upload their own.
              </v-card-text>
    
            </v-card>
          </v-dialog>
        </v-flex>

        <!-- server code button -->
        <v-flex xs6 offset-xs1 sm3 offset-sm4>
          <v-text-field outline :value="serverCode" label="Code" class="code-cpy-btn" readonly color="indigo" v-clipboard:copy="serverCode" v-clipboard:success="onCopy"></v-text-field>
        </v-flex>
  
        <!--
            <v-flex xs12>
              <v-btn @click="reloadPage" class="elevation-2" outline large color="black">
                Refresh Images
              </v-btn>
            </v-flex>
            -->
      </v-layout>
    </v-container>
  
    <v-container>
      
      <v-flex xs12>
        <Propeller :adChoice="0"/>
      </v-flex>
  
      <div v-if="serverExists">
        <Dropzone :id="id" />
        <br/>
        <ThumbnailGrid :id="id" />
        <br/>
      </div>
  
      <div v-if="!serverExists">
        <v-btn class="text-xs-center" icon :disabled="generateBtnClicked" v-on:click="generateServer()">
          <img class="btn-imag" src="../assets/i-up.png" />
        </v-btn>

        <br/>
        <br/>
        <span class="headline">Generate a new one...</span>
        <br/>
        <br/>
        <br/>

        <h2>...This server does not exist or has expired</h2>
      </div>
  
    </v-container>

  </div>
</template>

<script>
  import BackToTop from "vue-backtotop";
  import Dropzone from "./Dropzone.vue";
  import Header from "./Header.vue";
  import ThumbnailGrid from "./ThumbnailGrid.vue";
  import axios from "axios";
  import config from "../config";
  import lambda from "../lambda";
  import Propeller from "./ads/Propeller";
  import shortid from "shortid";
  import hri from "human-readable-ids";
  
  export default {
    name: "MainMenu",

    mounted(){
      lambda.getServerExpiration(this.$route.params.id.split("&")[0]).then(resp => {
        this.expiration = resp
      })
    },

    data() {
      return {
        expiration: '',
        message: `${window.location.hostname}/s/${
            this.$route.params.id.split("&")[0]
          }`,
        id: this.$route.params.id,
        serverExists: true,
        copyTextAlert: "Share",
        serverUrl: `${window.location.hostname}/s/${
            this.$route.params.id.split("&")[0]
          }`,
        serverCode: `${this.$route.params.id.split("&")[0]}`,
        generateBtnClicked: false
      };
    },
  
    components: {
      Dropzone,
      ThumbnailGrid,
      BackToTop,
      Header,
      Propeller
    },
  
    beforeCreate() {
      axios
        .get(
          `${config.AWS_LAMBDA_GET_LIST_OF_FILES_ENDPOINT}${
              this.$route.params.id.split("&")[0]
            }`
        )
        .then(response => {
          if (response.data.Contents.length == 0) {
            this.serverExists = false;
          } else {
            this.serverExists = true;
          }
        })
        .catch(e => {
          this.errors.push(e);
        });
    },
  
    methods: {

      generateServer: function() {
        //some absolute trash implementation of generating an id
        let h = hri.hri.random();
        h = h.split("-");
        h.pop(); //remove the last index because it is just a number 1-100 which is too weak for me
  
        let indx = Math.floor(Math.random() * 3) + 0; //get a random index from 0-2 to identify which array index to remove from 'h'
  
        let serverId = shortid
          .generate()
          .toLowerCase()
          .replace(/\W/g, "")
          .replace("_","")//random alphanumeric short id
          
        serverId = serverId.substring(0, 3); //get only the first 3 values
  
        //randomly remove a char from the serverId
        var removeChar = Math.floor(Math.random() * 3) + 0;
        if (removeChar < h.length) {
          serverId =
            serverId.substr(0, removeChar) + serverId.substr(removeChar + 1);
        }
  
        h.splice(indx, 0, serverId); //insert the random serverId into the 'h' array
  
        //concat the Id to '-' separated string
        var theId = "";
        for (let i = 0; i < h.length; i++) {
          theId += h[i];
          if (i != h.length - 1) {
            theId += "-";
          }
        }
  
        let payload = {
          serverName: theId
        };
        let endpoint = config.AWS_LAMBDA_GENERATE_SERVER_ENDPOINT;
  
        this.generateBtnClicked = true;
  
        axios
          .post(endpoint, payload)
          .then(res => {
            if (res.status == 200 && res.data) {
              //window.location.href = `s/${res.data}`;
              this.$router.replace({
                name: 'ServerRoom',
                params: {
                  id: res.data
                }
              })
              this.reloadPage()
            }
          })
          .catch(err => {
            console.log(err);
          });
      },

      reloadPage() {
        window.location.reload();
      },
  
      onCopy: function(e) {
        let btnId = e.trigger.getAttribute("class");
  
        if (btnId.indexOf("code") > -1) {
          this.serverCode = "Copied!";
        } else {
          this.serverUrl = "Copied!";
        }
        setTimeout(() => {
          if (btnId.indexOf("code") > -1) {
            this.serverCode = e.text;
          } else {
            this.serverUrl = e.text;
          }
        }, 1500);
      }
    }
  };
</script>

<style scoped>
  .spacer {
    height: 7vh;
  }
  
  .blink:focus,
  .blink:active {
    outline: none !important;
    box-shadow: none;
  }
  
  .alert {
    margin-bottom: 1px;
    height: 35px;
    line-height: 30px;
    padding: 0px 15px;
  }
  
  img {
    float: none;
  }
  
  .btt-btn {
    height: 7vh;
    width: 7vh;
  }
  
  .input-group__input {
    background-color: black;
  }
</style>


// WEBPACK FOOTER //
// src/components/ServerRoom.vue